import { Component, useEffect } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { router, entry } from './routes';

declare global {
  var __onautoRouteInventory:
    | {
        routes: Array<{
          pattern: string;
          path: string;
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
          entersFrom?: string;
        }>;
        entry: typeof entry;
      }
    | undefined;
}
class AppBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(_error: Error, _info: ErrorInfo) {}
  render() {
    return this.state.failed ? (
      <main className="mx-auto max-w-xl p-10">
        <h1 className="text-2xl font-semibold">TrustFile could not open this screen.</h1>
        <p className="mt-3 text-muted-foreground">Please reload and try again.</p>
      </main>
    ) : (
      this.props.children
    );
  }
}
export function App() {
  useEffect(() => {
    document.getElementById('root')?.setAttribute('data-app-ready', '1');
    globalThis.__onautoRouteInventory = {
      routes: Object.values(router.routesById)
        .filter((route) => route.id !== '__root__')
        .map((route) => {
          const data = route.options.staticData as {
            title: string;
            page: string;
            standalone: boolean;
            isPublic: boolean;
          };
          const path = route.fullPath;
          return {
            pattern: path.replace(/\$([A-Za-z][A-Za-z0-9]*)/g, '[$1]'),
            path,
            title: data.title,
            page: data.page,
            standalone: data.standalone,
            isPublic: data.isPublic,
          };
        }),
      entry,
    };
  }, []);
  return (
    <AppBoundary>
      <RouterProvider router={router} />
    </AppBoundary>
  );
}
